const convertResponseData = (response, field) => {
  switch (field.type) {
    case "picker": {
      if (response.value || !response.value.length) return null;
      return (response.value.values || []).map((r) =>
        parseInt(r.optionListValueID)
      );
    }
    case "address":
    case "date":
      return response.value;
    case "text":
    case "number": {
      return response.value.value;
    }
    default:
      return null;
  }
};

const convertResponseDataForBackend = async (responseValue, field) => {
  if (
    (!responseValue && responseValue !== 0 && responseValue !== "0") ||
    !field?.type
  )
    return null;
  switch (field.type) {
    case "picker": {
      return {
        values: responseValue.map((optionListValueID) => ({
          optionListValueID,
        })),
      };
    }
    case "address":
    case "date": {
      return responseValue;
    }
    case "text":
    case "number": {
      return { value: responseValue };
    }
    case "file": {
      if (typeof responseValue === "function") {
        await responseValue();
      }
      return undefined; // We do not send response data for file type directly. This is handled by responseValue when defined by CrossFeatureComponents/ExtendedFields/UploadField.js via setUploadCommand
    }
    default:
      return null;
  }
};

/**
 * takes responses from user and converts them into something the legacy back end can work with
 * @param {object} extendedFieldInputResponses
 * @param {object[]} fields - the data found in signuplist/<signupID>/publicView -> signuplist.signupItem[n].extenedFields
 * @returns
 */
const convertExtendedFieldInputResponses = async (
  extendedFieldInputResponses,
  fields
) => {
  let formatted = {};
  for (const userID in extendedFieldInputResponses) {
    for (const fieldID in extendedFieldInputResponses[userID]) {
      const getResponseValue = () => {
        if (
          extendedFieldInputResponses[userID][fieldID] === 0 ||
          extendedFieldInputResponses[userID][fieldID]
        ) {
          return extendedFieldInputResponses[userID][fieldID];
        } else {
          return null;
        }
      };

      let responseValue = getResponseValue();
      const field = fields.find(
        (f) => f.fieldID.toString() === fieldID.toString()
      );

      const fieldIsNumberAndValueIsZero =
        field?.type === "number" && responseValue === 0;

      if (fieldIsNumberAndValueIsZero || responseValue) {
        if (!field) continue;

        if (!formatted[userID]) formatted[userID] = {};
        formatted[userID][fieldID] = await convertResponseDataForBackend(
          responseValue,
          field
        );
      }
    }
  }
  return formatted;
};

const convertSharedExtendedFieldInputResponses = async (
  sharedExtenededFieldInputResponses,
  fields
) => {
  let formatted = {};
  for (const fieldID in sharedExtenededFieldInputResponses) {
    const responseValue = sharedExtenededFieldInputResponses[fieldID] || null;
    if (responseValue) {
      const field = fields.find(
        (f) => f.fieldID.toString() === fieldID.toString()
      );
      if (field) {
        formatted[fieldID] = await convertResponseDataForBackend(
          responseValue,
          field
        );
      }
    }
  }
  return formatted;
};

export {
  convertExtendedFieldInputResponses,
  convertSharedExtendedFieldInputResponses,
};
